import { render, staticRenderFns } from "./PrepTransProdSelectDialog.vue?vue&type=template&id=24f58e6f&scoped=true"
import script from "./PrepTransProdSelectDialog.vue?vue&type=script&lang=js"
export * from "./PrepTransProdSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f58e6f",
  null
  
)

export default component.exports